export const FLOWS_CU = [
    [ 14,	18.5,	25,	32,	43,	57,	75,	92,	110,	139,	167,	192,	219,	248,	291,	334 ],
    [ 13,	17.5,	23,	29,	39,	52,	68,	83,	99,	125,	150,	172,	196,	223,	261,	298 ],
    [ 18.5,	25,	33,	42,	57,	76,	99,	121,	145,	183,	220,	253,	290,	329,	386,	442 ],
    [ 16.5,	22,	30,	38,	51,	68,	89,	109,	130,	164,	197,	227,	259,	295,	346,	396 ],
    [ 16.5,	23,	30,	38,	52,	69,	90,	111,	133,	168,	201,	232,	258,	294,	344,	394 ],
    [ 15,	20,	27,	34,	46,	62,	80,	99,	118,	149,	179,	206,	225,	255,	297,	339 ],
    [ 22,	30,	40,	51,	69,	91,	119,	146,	175,	221,	265,	305,	334,	384,	459,	532 ],
    [ 19.5,	26,	35,	44,	60,	80,	105,	128,	154,	194,	233,	268,	300,	340,	398,	455 ],
    [ 22,	30,	40,	51,	70,	94,	119,	148,	180,	232,	282,	328,	379,	434,	514,	593 ],
    [ 18.5,	25,	34,	43,	60,	80,	101,	126,	153,	196,	238,	276,	319,	364,	430,	497 ],
    [ 26,	36,	49,	63,	86,	115,	149,	185,	225,	289,	352,	410,	473,	542,	641,	741 ],
    [ 23,	32,	42,	54,	75,	100,	127,	158,	192,	246,	298,	346,	399,	456,	538,	621 ],
    [ 19.5,	27,	36,	46,	63,	85,	112,	138,	168,	213,	258,	299,	344,	392,	461,	530 ],
    [ 17.5,	24,	32,	41,	57,	76,	96,	119,	144,	184,	223,	259,	299,	341,	403,	464 ],
    [ 24,	33,	45,	58,	80,	107,	138,	171,	209,	269,	328,	382,	441,	506,	599,	693 ],
    [ 22,	30,	40,	52,	71,	96,	119,	147,	179,	229,	278,	322,	371,	424,	500,	577 ],
    [ 19.5,	26,	35,	46,	63,	85,	110,	137,	167,	216,	264,	308,	356,	409,	485,	561 ],
    [ 24,	33,	45,	58,	80,	107,	135,	169,	207,	268,	328,	383,	444,	510,	607,	703 ],
    [ 22,	30,	40,	52,	71,	96,	131,	162,	196,	251,	304,	352,	406,	463,	546,	629 ],
    [ 19.5,	26,	35,	46,	63,	85,	114,	143,	174,	225,	275,	321,	372,	427,	507,	587 ],
    [ 27,	37,	50,	64,	88,	119,	161,	200,	242,	310,	377,	437,	504,	575,	679,	783 ],
    [ 24,	33,	45,	58,	80,	107,	141,	176,	216,	279,	342,	400,	464,	533,	634,	736 ],
    [ 0,	0,	0,	0,	0,	0,	146,	181,	219,	281,	341,	396,	456,	521,	615,	709 ],
    [ 0,	0,	0,	0,	0,	0,	182,	226,	275,	353,	430,	500,	577,	661,	781,	902 ],
    [ 0,	0,	0,	0,	0,	0,	130,	162,	197,	254,	311,	362,	419,	480,	569,	659 ],
    [ 0,	0,	0,	0,	0,	0,	161,	201,	246,	318,	389,	454,	527,	605,	719,	833 ],
    [ 14.5,	19.5,	26,	34,	46,	61,	80,	99,	119,	151,	182,	210,	240,	273,	320,	334 ],
    [ 13.5,	18,	24,	31,	42,	56,	73,	89,	108,	136,	164,	188,	216,	245,	286,	298 ],
    [ 19,	26,	36,	45,	61,	81,	106,	131,	158,	200,	241,	278,	318,	362,	424,	442 ],
    [ 17,	23,	31,	40,	54,	73,	95,	117,	141,	179,	216,	249,	285,	324,	380,	396 ],
    [ 17.5,	24,	32,	41,	57,	76,	101,	125,	151,	192,	232,	269,	309,	353,	415,	0 ],
    [ 15.5,	21,	28,	36,	50,	68,	89,	110,	134,	171,	207,	239,	275,	314,	369,	0 ],
    [ 23,	31,	42,	54,	75,	100,	133,	164,	198,	253,	306,	354,	402,	472,	555,	0 ],
    [ 20,	28,	37,	48,	66,	88,	117,	144,	175,	222,	269,	312,	355,	417,	490,	0 ],
    [ 19.5,	26,	35,	46,	63,	85,	112,	138,	168,	213,	258,	299,	344,	392,	461,	0 ],
    [ 15.5,	21,	28,	36,	57,	76,	101,	125,	151,	192,	232,	269,	309,	353,	415,	0 ],
    [ 24,	33,	45,	58,	80,	107,	142,	175,	212,	270,	327,	0,	0,	0,	0,	0 ],
    [ 20,	28,	37,	48,	71,	96,	127,	157,	190,	242,	293,	0,	0,	0,	0,	0 ],
    [ 20,	26,	34,	42,	57,	74,	95,	114,	141,	172,	202,	233,	265,	297,	347,	0 ],
    [ 18,	23,	31,	39,	51,	67,	85,	103,	127,	154,	181,	208,	236,	264,	308,	0 ],
    [ 23,	31,	40,	49,	66,	86,	110,	133,	164,	200,	235,	271,	309,	347,	405,	509 ],
    [ 21,	28,	36,	44,	60,	77,	99,	120,	147,	178,	210,	241,	274,	306,	357,	448 ],
    [ 19,	24,	32,	41,	55,	70,	91,	111,	138,	168,	200,	230,	263,	295,	347,	0 ],
    [ 16,	21,	27,	34,	46,	60,	77,	94,	116,	142,	168,	194,	221,	249,	293,	0 ],
    [ 22,	29,	37,	47,	63,	82,	106,	130,	160,	196,	232,	268,	306,	345,	405,	510 ],
    [ 19,	24,	32,	40,	53,	70,	90,	109,	135,	166,	195,	226,	258,	291,	341,	429 ],
    [ 17,	23,	30,	37,	51,	66,	86,	105,	130,	159,	189,	218,	248,	279,	328,	0 ],
    [ 15,	19,	25,	32,	43,	56,	72,	88,	109,	135,	159,	184,	210,	236,	277,	0 ],
    [ 21,	27,	35,	45,	60,	78,	101,	124,	153,	188,	223,	258,	295,	331,	389,	0 ],
    [ 17,	23,	29,	37,	50,	66,	85,	104,	128,	158,	187,	217,	248,	278,	328,	0 ],
    [ 30,	40,	55,	70,	95,	130,	180,	220,	280,	350,	410,	480,	0,	0,	0,	0 ],
];

export const FLOWS_AL = [
    [ 0, 0, 0, 0, 0, 44.46, 58.5, 71.76, 85.8, 108.42, 130.26, 149.76, 170.82, 193.44, 226.98, 260.52 ],
    [ 0, 0, 0, 0, 0, 40.56, 53.04, 64.74, 77.22, 97.5, 117, 134.16, 152.88, 173.94, 203.58, 232.44 ],
    [ 0, 0, 0, 0, 0, 59.28, 77.22, 94.38, 113.1, 142.74, 171.6, 197.34, 226.2, 256.62, 301.08, 344.76 ],
    [ 0, 0, 0, 0, 0, 53.04, 69.42, 85.02, 101.4, 127.92, 153.66, 177.06, 202.02, 230.1, 269.88, 308.88 ],
    [ 0, 0, 0, 0, 0, 53.82, 70.2, 86.58, 103.74, 131.04, 156.78, 180.96, 201.24, 229.32, 268.32, 307.32 ],
    [ 0, 0, 0, 0, 0, 48.36, 62.4, 77.22, 92.04, 116.22, 139.62, 160.68, 175.5, 198.9, 231.66, 264.42 ],
    [ 0, 0, 0, 0, 0, 70.98, 92.82, 113.88, 136.5, 172.38, 206.7, 237.9, 260.52, 299.52, 358.02, 414.96 ],
    [ 0, 0, 0, 0, 0, 62.4, 81.9, 99.84, 120.12, 151.32, 181.74, 209.04, 234, 265.2, 310.44, 354.9 ],
    [ 0, 0, 0, 0, 0, 73.32, 92.82, 115.44, 140.4, 180.96, 219.96, 255.84, 295.62, 338.52, 400.92, 462.54 ],
    [ 0, 0, 0, 0, 0, 62.4, 78.78, 98.28, 119.34, 152.88, 185.64, 215.28, 248.82, 283.92, 335.4, 387.66 ],
    [ 0, 0, 0, 0, 0, 89.7, 116.22, 144.3, 175.5, 225.42, 274.56, 319.8, 368.94, 422.76, 499.98, 577.98 ],
    [ 0, 0, 0, 0, 0, 78, 99.06, 123.24, 149.76, 191.88, 232.44, 269.88, 311.22, 355.68, 419.64, 484.38 ],
    [ 0, 0, 0, 0, 0, 66.3, 87.36, 107.64, 131.04, 166.14, 201.24, 233.22, 268.32, 305.76, 359.58, 413.4 ],
    [ 0, 0, 0, 0, 0, 59.28, 74.88, 92.82, 112.32, 143.52, 173.94, 202.02, 233.22, 265.98, 314.34, 361.92 ],
    [ 0, 0, 0, 0, 0, 83.46, 107.64, 133.38, 163.02, 209.82, 255.84, 297.96, 343.98, 394.68, 467.22, 540.54 ],
    [ 0, 0, 0, 0, 0, 74.88, 92.82, 114.66, 139.62, 178.62, 216.84, 251.16, 289.38, 330.72, 390, 450.06 ],
    [ 0, 0, 0, 0, 0, 66.3, 85.8, 106.86, 130.26, 168.48, 205.92, 240.24, 277.68, 319.02, 378.3, 437.58 ],
    [ 0, 0, 0, 0, 0, 83.46, 105.3, 131.82, 161.46, 209.04, 255.84, 298.74, 346.32, 397.8, 473.46, 548.34 ],
    [ 0, 0, 0, 0, 0, 74.88, 102.18, 126.36, 152.88, 195.78, 237.12, 274.56, 316.68, 361.14, 425.88, 490.62 ],
    [ 0, 0, 0, 0, 0, 66.3, 88.92, 111.54, 135.72, 175.5, 214.5, 250.38, 290.16, 333.06, 395.46, 457.86 ],
    [ 0, 0, 0, 0, 0, 92.82, 125.58, 156, 188.76, 241.8, 294.06, 340.86, 393.12, 448.5, 529.62, 610.74 ],
    [ 0, 0, 0, 0, 0, 83.46, 109.98, 137.28, 168.48, 217.62, 266.76, 312, 361.92, 415.74, 494.52, 574.08 ],
    [ 0, 0, 0, 0, 0, 0, 113.88, 141.18, 170.82, 219.18, 265.98, 308.88, 355.68, 406.38, 479.7, 553.02 ],
    [ 0, 0, 0, 0, 0, 0, 141.96, 176.28, 214.5, 275.34, 335.4, 390, 450.06, 515.58, 609.18, 703.56 ],
    [ 0, 0, 0, 0, 0, 0, 101.4, 126.36, 153.66, 198.12, 242.58, 282.36, 326.82, 374.4, 443.82, 514.02 ],
    [ 0, 0, 0, 0, 0, 0, 125.58, 156.78, 191.88, 248.04, 303.42, 354.12, 411.06, 471.9, 560.82, 649.74 ],
    [ 0, 0, 0, 0, 0, 47.58, 62.4, 77.22, 92.82, 117.78, 141.96, 163.8, 187.2, 212.94, 249.6, 260.52 ],
    [ 0, 0, 0, 0, 0, 43.68, 56.94, 69.42, 84.24, 106.08, 127.92, 146.64, 168.48, 191.1, 223.08, 232.44 ],
    [ 0, 0, 0, 0, 0, 63.18, 82.68, 102.18, 123.24, 156, 187.98, 216.84, 248.04, 282.36, 330.72, 344.76 ],
    [ 0, 0, 0, 0, 0, 56.94, 74.1, 91.26, 109.98, 139.62, 168.48, 194.22, 222.3, 252.72, 296.4, 308.88 ],
    [ 0, 0, 0, 0, 0, 59.28, 78.78, 97.5, 117.78, 149.76, 180.96, 209.82, 241.02, 275.34, 323.7, 0 ],
    [ 0, 0, 0, 0, 0, 53.04, 69.42, 85.8, 104.52, 133.38, 161.46, 186.42, 214.5, 244.92, 287.82, 0 ],
    [ 0, 0, 0, 0, 0, 78, 103.74, 127.92, 154.44, 197.34, 238.68, 276.12, 313.56, 368.16, 432.9, 0 ],
    [ 0, 0, 0, 0, 0, 68.64, 91.26, 112.32, 136.5, 173.16, 209.82, 243.36, 276.9, 325.26, 382.2, 0 ],
    [ 0, 0, 0, 0, 0, 66.3, 87.36, 107.64, 131.04, 166.14, 201.24, 233.22, 268.32, 305.76, 359.58, 0 ],
    [ 0, 0, 0, 0, 0, 59.28, 78.78, 97.5, 117.78, 149.76, 180.96, 209.82, 241.02, 275.34, 323.7, 0 ],
    [ 0, 0, 0, 0, 0, 83.46, 110.76, 136.5, 165.36, 210.6, 255.06, 0, 0, 0, 0, 0 ],
    [ 0, 0, 0, 0, 0, 74.88, 99.06, 122.46, 148.2, 188.76, 228.54, 0, 0, 0, 0, 0 ],
    [ 0, 0, 0, 0, 0, 57.72, 74.1, 88.92, 109.98, 134.16, 157.56, 181.74, 206.7, 231.66, 270.66, 0 ],
    [ 0, 0, 0, 0, 0, 52.26, 66.3, 80.34, 99.06, 120.12, 141.18, 162.24, 184.08, 205.92, 240.24, 0 ],
    [ 0, 0, 0, 0, 0, 67.08, 85.8, 103.74, 127.92, 156, 183.3, 211.38, 241.02, 270.66, 315.9, 397.02 ],
    [ 0, 0, 0, 0, 0, 60.06, 77.22, 93.6, 114.66, 138.84, 163.8, 187.98, 213.72, 238.68, 278.46, 349.44 ],
    [ 0, 0, 0, 0, 0, 54.6, 70.98, 86.58, 107.64, 131.04, 156, 179.4, 205.14, 230.1, 270.66, 0 ],
    [ 0, 0, 0, 0, 0, 46.8, 60.06, 73.32, 90.48, 110.76, 131.04, 151.32, 172.38, 194.22, 228.54, 0 ],
    [ 0, 0, 0, 0, 0, 63.96, 82.68, 101.4, 124.8, 152.88, 180.96, 209.04, 238.68, 269.1, 315.9, 397.8 ],
    [ 0, 0, 0, 0, 0, 54.6, 70.2, 85.02, 105.3, 129.48, 152.1, 176.28, 201.24, 226.98, 265.98, 334.62 ],
    [ 0, 0, 0, 0, 0, 51.48, 67.08, 81.9, 101.4, 124.02, 147.42, 170.04, 193.44, 217.62, 255.84, 0 ],
    [ 0, 0, 0, 0, 0, 43.68, 56.16, 68.64, 85.02, 105.3, 124.02, 143.52, 163.8, 184.08, 216.06, 0 ],
    [ 0, 0, 0, 0, 0, 60.84, 78.78, 96.72, 119.34, 146.64, 173.94, 201.24, 230.1, 258.18, 303.42, 0 ],
    [ 0, 0, 0, 0, 0, 51.48, 66.3, 81.12, 99.84, 123.24, 145.86, 169.26, 193.44, 216.84, 255.84, 0 ],
    [ 0, 0, 0, 0, 0, 101.4, 140.4, 171.6, 218.4, 273, 319.8, 374.4, 0, 0, 0, 0 ],
];

export const K1_PVC_AIR = [
	1.22,
	1.17,
	1.12,
	1.06,
	1,
	0.94,
	0.87,
	0.79,
	0.71,
	0.61,
	0.5,
	0.4,
];

export const K1_PHOTOVOLTAIC = [
	1,
	0.91,
	0.82,
	0.71,
	0.58,
	0.41,
	0.20,
];

export const K1_RUBBER_AIR = [
	1.15,
	1.12,
	1.08,
	1.04,
	1,
	0.96,
	0.91,
	0.87,
	0.82,
	0.76,
	0.71,
	0.65,
	0.58,
	0.5,
	0.41,
];

export const K1_PVC_GROUND = [
	1.1,
	1.05,
	1,
	0.95,
	0.89,
	0.84,
	0.77,
	0.71,
	0.63,
	0.55,
	0.45,
	0.4,
];

export const K1_RUBBER_GROUND = [
	1.07,
	1.04,
	1,
	0.96,
	0.93,
	0.89,
	0.85,
	0.8,
	0.76,
	0.71,
	0.65,
	0.6,
	0.53,
	0.46,
	0.38,
];

export const K2_FACTORS = [
	[1,	0.8,	0.7,	0.65,	0.6,	0.57,	0.54,	0.52,	0.5,	0.45,	0.41,	0.38],
	[1,	0.85,	0.79,	0.75,	0.73,	0.72,	0.72,	0.71,	0.7,	0.7,	0.7,	0.7],
	[0.95,	0.81,	0.72,	0.68,	0.66,	0.64,	0.63,	0.62,	0.61,	0.61,	0.61,	0.61],
	[1,	0.88,	0.82,	0.77,	0.75,	0.73,	0.73,	0.72,	0.72,	0.72,	0.72,	0.72],
	[1,	0.87,	0.82,	0.8,	0.8,	0.79,	0.79,	0.78,	0.78,	0.78,	0.78,	0.78],
	[1,	0.87,	0.8,	0.77,	0.73,	0.73,	0.73,	0.73,	0.68,	0.68,	0.68,	0.68],
	[1,	0.86,	0.79,	0.76,	0.71,	0.71,	0.71,	0.71,	0.66,	0.66,	0.66,	0.66],
	[1,	0.99,	0.96,	0.92,	0.87,	0.87,	0.87,	0.87,	0.87,	0.87,	0.87,	0.87],
	[1,	0.98,	0.95,	0.91,	0.85,	0.85,	0.85,	0.85,	0.85,	0.85,	0.85,	0.85],
	[1,	0.88,	0.81,	0.76,	0.71,	0.71,	0.71,	0.71,	0.7,	0.7,	0.7,	0.7],
	[1,	0.91,	0.88,	0.87,	0.85,	0.85,	0.85,	0.85,	0.85,	0.85,	0.85,	0.85],
	[1,	0.86,	0.8,	0.78,	0.76,	0.76,	0.76,	0.76,	0.73,	0.73,	0.73,	0.73],
	[1,	0.85,	0.79,	0.76,	0.73,	0.73,	0.73,	0.73,	0.7,	0.7,	0.7,	0.7],
	[1,	0.99,	0.98,	0.97,	0.96,	0.96,	0.96,	0.96,	0.96,	0.96,	0.96,	0.96],
	[1,	0.98,	0.97,	0.96,	0.93,	0.93,	0.93,	0.93,	0.93,	0.93,	0.93,	0.93],
	[0.96,	0.87,	0.81,	0.81,	0.81,	0.81,	0.81,	0.81,	0.81,	0.81,	0.81,	0.81],
	[0.95,	0.85,	0.78,	0.78,	0.78,	0.78,	0.78,	0.78,	0.78,	0.78,	0.78,	0.78],
	[0.95,	0.84,	0.84,	0.84,	0.84,	0.84,	0.84,	0.84,	0.84,	0.84,	0.84,	0.84],
	[0.98,	0.93,	0.89,	0.89,	0.89,	0.89,	0.89,	0.89,	0.89,	0.89,	0.89,	0.89],
	[0.97,	0.9,	0.86,	0.86,	0.86,	0.86,	0.86,	0.86,	0.86,	0.86,	0.86,	0.86],
	[0.97,	0.93,	0.89,	0.89,	0.89,	0.89,	0.89,	0.89,	0.89,	0.89,	0.89,	0.89],
	[0.96,	0.92,	0.86,	0.86,	0.86,	0.86,	0.86,	0.86,	0.86,	0.86,	0.86,	0.86],
	[1,	0.9,	0.86,	0.86,	0.86,	0.86,	0.86,	0.86,	0.86,	0.86,	0.86,	0.86],
	[0.97,	0.95,	0.93,	0.93,	0.93,	0.93,	0.93,	0.93,	0.93,	0.93,	0.93,	0.93],
	[0.96,	0.94,	0.9,	0.9,	0.9,	0.9,	0.9,	0.9,	0.9,	0.9,	0.9,	0.9],
	[1,	0.85,	0.75,	0.7,	0.65,	0.6,	0.6,	0.6,	0.6,	0.6,	0.6,	0.6],
	[1,	0.9,	0.85,	0.8,	0.8,	0.8,	0.8,	0.8,	0.8,	0.8,	0.8,	0.8],
	[1,	0.95,	0.9,	0.85,	0.85,	0.8,	0.8,	0.8,	0.8,	0.8,	0.8,	0.8],
	[1,	0.95,	0.95,	0.9,	0.9,	0.9,	0.9,	0.9,	0.9,	0.9,	0.9,	0.9],
	[1,	0.85,	0.75,	0.7,	0.65,	0.6,	0.6,	0.6,	0.6,	0.6,	0.6,	0.6],
	[1,	0.9,	0.85,	0.8,	0.8,	0.8,	0.8,	0.8,	0.8,	0.8,	0.8,	0.8],
	[1,	0.95,	0.9,	0.85,	0.85,	0.8,	0.8,	0.8,	0.8,	0.8,	0.8,	0.8],
	[1,	0.95,	0.95,	0.9,	0.9,	0.9,	0.9,	0.9,	0.9,	0.9,	0.9,	0.9],
];

export const K3_GROUND = [
	1.02,
	1.013,
	1,
	0.98,
	0.96,
	0.94
];

export const K4_UNI_GROUND = [
	1.2,
	1.16,
	1.11,
	1,
	0.91
];

export const K4_MULTI_GROUND = [
	1.16,
	1.14,
	1.1,
	1,
	0.92
];

export const KS_2LAYERS = [
	0.8,
	0.8,
	1
];

export const KS_3LAYERS = [
	0.73,
	0.75,
	0.78
];

// Tabella UNEL 35024-1 e 35024-2
export const K = [
	1,
	0.8,
	0.7,
	0.65,
	0.6,
	0.57,
	0.54,
	0.52,
	0.5,
	0.45,
	0.41,
	0.38
]

// N.circuiti associati ai corrisp. valori di K
export const NK = [
	1,
	2,
	3,
	4,
	5,
	6,
	7,
	8,
	9,
	12,
	16,
	20,
]

export const NORMAL_SECTIONS = [
	1.5,
	2.5,
	4,
	6,
	10,
	16,
	25,
	35,
	50,
	70,
	95,
	120,
	150,
	185,
	240,
	300,
];

export const REACTANCE_MULTI = [
	0.118,
	0.109,
	0.101,
	0.0955,
	0.0861,
	0.0817,
	0.0813,
	0.0783,
	0.0779,
	0.0751,
	0.0762,
	0.074,
	0.0745,
	0.0742,
	0.0752,
	0.075,
];

export const REACTANCE_UNI = [
	0.168,
	0.155,
	0.143,
	0.135,
	0.119,
	0.112,
	0.106,
	0.101,
	0.101,
	0.0965,
	0.0975,
	0.0939,
	0.0928,
	0.0908,
	0.0902,
	0.0895,
];

export const KF = [
	1.00,
	0.80,
	0.70,
	0.65,
	0.6,
	0.57,
	0.54,
	0.52,
	0.50,
	0.48,
];